export default __webpack_public_path__ + "static/logo-546a2f2309ca3ec13fa446fd749042fb.svg";